import { render, staticRenderFns } from "./Embulks.vue?vue&type=template&id=448152bf&"
import script from "./Embulks.vue?vue&type=script&lang=ts&"
export * from "./Embulks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports